import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { endpoints } from '../../../environments/environment';


@Injectable()
export class CurrentTimeService {

	constructor(private http: HttpClient) {
	}
	getCurrentTimeInServer(): Observable<any> {
		return this.http.get<any>(`${endpoints.utils.currentTimeServer}`);
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/services/current-time.service.ts